import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, HStack, Link, Stack, Text } from '@chakra-ui/react'
import React from 'react'

export const Faqs = () => {

  return (
    <Stack w="35%" margin="auto" alignSelf="center" p={5}>
        <HStack>
        <Accordion allowToggle >
  <Text bgColor="rgb(245,245,245)" p={3}>ABOUT HOST BY ZOOMCAR AND THE CAR</Text>
  <AccordionItem>
    <h2>
      <AccordionButton>
        <Box flex='1' textAlign='left'>
        What is Host by Zoomcar?
        </Box>
        <AccordionIcon />
      </AccordionButton>
    </h2>
    <AccordionPanel pb={4} color="gray.400">
      <ul>
        <li>Host by Zoomcar is a unique community vehicle pooling program for Car owners to let them share their cars when it's not in use on Zoomcar platform to earn money and rewards(Rs. 7,500/-* joining bonus for 7 seater cars and booking revenue).</li>
      </ul>
    </AccordionPanel>
  </AccordionItem>
  <AccordionItem>
    <h2>
      <AccordionButton>
        <Box flex='1' textAlign='left'>
        How does Host by Zoomcar work?
        </Box>
        <AccordionIcon />
      </AccordionButton>
    </h2>
    <AccordionPanel pb={4} color="gray.400">
    
    <ul>
        <li>Visit the Host by Zoomcar website, select your city, login, fill a form with basic details and agree to terms & conditions </li>
        <li>Enter personal & car details…done!</li>
        <li>A dedicated Zoomcar relationship manager will contact you and guide you further. </li>
        <li>Next, he will pick up your car and get the Vehicle Safety Monitoring & Keyless entry devices installed</li>
        <li>Your car is now ready to accept bookings.</li>
     
      </ul>
      Here are the many benefits of listing your car on Host by Zoomcar: 
      <li>List your car for free and sit back and earn. </li>
      <li>You can reduce the idle time of the car by listing it on Zoomcar and recover car-related expenses </li>
      <li>Reduce your car ownership cost</li>
      <li>Reduce your maintenance cost by renting out the car when you don’t need it.</li>
      <li>While you earn money, you can also reduce your carbon footprint and do your bit for the environment.</li>
      
    </AccordionPanel>
  </AccordionItem>
  <AccordionItem>
    <h2>
      <AccordionButton>
        <Box flex='1' textAlign='left'>
        Which cars can I list? What are the variants?
        </Box>
        <AccordionIcon />
      </AccordionButton>
    </h2>
    <AccordionPanel pb={4} color="gray.400">
      <ul>
        <li>You can list any car model ranging from hatchbacks to SUVs. Fill in the interest form and our team will get back on eligibility of your car.</li>
      </ul>
    </AccordionPanel>
  </AccordionItem>
  <AccordionItem>
    <h2>
      <AccordionButton>
        <Box flex='1' textAlign='left'>
        How soon can I get on-boarded to the platform?
        </Box>
        <AccordionIcon />
      </AccordionButton>
    </h2>
    <AccordionPanel pb={4} color="gray.400">
      <ul>
        <li>From the time Host expresses interest to list the car, the time period taken usually would be between 3-7 days.</li>
      </ul>
    </AccordionPanel>
  </AccordionItem>
  <AccordionItem>
    <h2>
      <AccordionButton>
        <Box flex='1' textAlign='left'>
        When will my car listing start?
        </Box>
        <AccordionIcon />
      </AccordionButton>
    </h2>
    <AccordionPanel pb={4} color="gray.400">
      <ul>
        <li>Once your car has been onboarded you can start creating listing from your Host app at your will.</li>
      </ul>
    </AccordionPanel>
  </AccordionItem>
  <AccordionItem>
    <h2>
      <AccordionButton>
        <Box flex='1' textAlign='left'>
        Who will be responsible for the service and maintenance?
        </Box>
        <AccordionIcon />
      </AccordionButton>
    </h2>
    <AccordionPanel pb={4} color="gray.400">
      <ul>
        <li>The servicing and maintenance of the car would have to be handled by the car owner. </li>
      </ul>
    </AccordionPanel>
  </AccordionItem>
  <AccordionItem>
    <h2>
      <AccordionButton>
        <Box flex='1' textAlign='left'>
        How can I reduce my car ownership and maintenance cost by sharing the car on Host by Zoomcar platform?
        </Box>
        <AccordionIcon />
      </AccordionButton>
    </h2>
    <AccordionPanel pb={4} color="gray.400">
      <ul>
        <li>Host by Zoomcar is a unique community vehicle pooling program for Car owners to let them share their cars when it's not in use on Zoomcar platform to earn money and rewards(Rs. 7,500/-* joining bonus for 7 seater cars and booking revenue).</li>
      </ul>
    </AccordionPanel>
  </AccordionItem>
  <AccordionItem>
    <h2>
      <AccordionButton>
        <Box flex='1' textAlign='left'>
        Can I stop listing my car any time I like?
        </Box>
        <AccordionIcon />
      </AccordionButton>
    </h2>
    <AccordionPanel pb={4} color="gray.400">
      <ul>
        <li>Host by Zoomcar is a unique community vehicle pooling program for Car owners to let them share their cars when it's not in use on Zoomcar platform to earn money and rewards(Rs. 7,500/-* joining bonus for 7 seater cars and booking revenue).</li>
      </ul>
    </AccordionPanel>
  </AccordionItem>
  <AccordionItem>
    <h2>
      <AccordionButton>
        <Box flex='1' textAlign='left'>
        What maintenance requirement does my car have to meet in order to be eligible for listing?
        </Box>
        <AccordionIcon />
      </AccordionButton>
    </h2>
    <AccordionPanel pb={4} color="gray.400">
      <ul>
        <li>Host by Zoomcar is a unique community vehicle pooling program for Car owners to let them share their cars when it's not in use on Zoomcar platform to earn money and rewards(Rs. 7,500/-* joining bonus for 7 seater cars and booking revenue).</li>
      </ul>
    </AccordionPanel>
  </AccordionItem>
  <AccordionItem>
    <h2>
      <AccordionButton>
        <Box flex='1' textAlign='left'>
        What is the minimum listing duration
        </Box>
        <AccordionIcon />
      </AccordionButton>
    </h2>
    <AccordionPanel pb={4} color="gray.400">
      <ul>
        <li>Host by Zoomcar is a unique community vehicle pooling program for Car owners to let them share their cars when it's not in use on Zoomcar platform to earn money and rewards(Rs. 7,500/-* joining bonus for 7 seater cars and booking revenue).</li>
      </ul>
    </AccordionPanel>
  </AccordionItem>
  <AccordionItem>
    <h2>
      <AccordionButton>
        <Box flex='1' textAlign='left'>
        Is CNG variant accepted?
        </Box>
        <AccordionIcon />
      </AccordionButton>
    </h2>
    <AccordionPanel pb={4} color="gray.400">
      <ul>
        <li>Host by Zoomcar is a unique community vehicle pooling program for Car owners to let them share their cars when it's not in use on Zoomcar platform to earn money and rewards(Rs. 7,500/-* joining bonus for 7 seater cars and booking revenue).</li>
      </ul>
    </AccordionPanel>
  </AccordionItem>
 

  


</Accordion>

        </HStack>
    
    </Stack>
  )
}
